/* Sternkerze — Zuendhoelzer als Zugabe (Schritt 4 der Mini Sternkerze).
   Die Karte laesst sich an- und abwaehlen; ist sie aktiv, legt der
   Kauf das gewaehlte Zuendholz-Produkt als eigene Position dazu und
   frischt danach den Warenkorb-Auszug auf. */
(function () {
  function einrichten(wurzel) {
    var karte = wurzel.querySelector('[data-sk-zuend-toggle]');
    var motive = wurzel.querySelector('.sk-zuend__motive');
    var bild = wurzel.querySelector('[data-sk-zuend-bild]');
    if (!karte) return;

    karte.addEventListener('click', function () {
      var an = !wurzel.classList.contains('sk-zuend--an');
      wurzel.classList.toggle('sk-zuend--an', an);
      karte.setAttribute('aria-pressed', an ? 'true' : 'false');
      if (motive) motive.hidden = !an;
    });

    if (motive && bild) {
      motive.addEventListener('change', function (e) {
        if (e.target.name === 'sk-zuend-motiv' && e.target.dataset.bild) {
          bild.src = e.target.dataset.bild;
        }
      });
    }
  }

  /* Vor dem Theme-Handler einhaken (Capture am Dokument): die
     Zuendhoelzer laufen als eigene Anfrage parallel zur Kerze. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!form.checkValidity()) return;

    var wurzel = document.querySelector('[data-sk-zuend]');
    if (!wurzel || !wurzel.classList.contains('sk-zuend--an')) return;
    var motiv = wurzel.querySelector('input[name="sk-zuend-motiv"]:checked');
    if (!motiv) return;

    fetch((window.theme && theme.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(motiv.value, 10), quantity: 1 }] })
    }).then(function () {
      // erst den Theme-Auszug rechnen lassen, dann auffrischen
      setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }, 700);
    });
  }, true);

  function start() {
    document.querySelectorAll('[data-sk-zuend]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
